import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserPromotionEffects } from './effects/promotion.effects';
import { ModalConfirmComponent } from './modals/modal-confirm/modal-confirm.component';
import { ModalPromotionCreateAddBackgroundComponent } from './promotion-create/modal-promotion-create-add-background/modal-promotion-create-add-background.component';
import { PromotionCreateComponent } from './promotion-create/promotion-create.component';
import { ModalPromotionUpdateAddBackgroundComponent } from './promotion-update/modal-promotion-update-add-background/modal-promotion-update-add-background.component';
import { PromotionUpdateComponent } from './promotion-update/promotion-update.component';
import { PromotionComponent } from './promotion.component';
import { PROMOTION_ROUTES } from './promotion.routes';
import * as fromPromotions from './reducers/promotion.reducer';
import { SmashPromotionModule } from '@app/shared/modules/smash-promotion/smash-promotion.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { SmashDataTableModule } from '@app/shared/modules/smash-data-table/smash-data-table.module';
import { SmashScrollbarModule } from '@app/shared/modules/smash-scrollbar/smash-scrollbar.module';


@NgModule({
  declarations: [
    PromotionComponent,
    PromotionCreateComponent,
    PromotionUpdateComponent,
    ModalConfirmComponent,
    ModalPromotionCreateAddBackgroundComponent,
    ModalPromotionUpdateAddBackgroundComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(PROMOTION_ROUTES),
    StoreModule.forFeature(fromPromotions.promotionFeatureKey, fromPromotions.reducer),
    EffectsModule.forFeature([UserPromotionEffects]),
    SmashPromotionModule,
    SmashFormsModule,
    SmashDataTableModule,
    SmashScrollbarModule,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PromotionModule { }
